import "react";

import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

const calendarPrefix = "DRMPContainer";
export const calendarClasses = {
  root: `${calendarPrefix}-root`,
};

export const DRMPContainer = styled(Stack)(({ theme }) => ({
  [`&.${calendarClasses.root}`]: {
    flexDirection: "row",
    rowGap: theme.spacing(3),
    columnGap: theme.spacing(4),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
}));

const monthItemPrefix = "DRMPMonthItemContainer";
export const monthItemClasses = {
  root: `${monthItemPrefix}-root`,
  button: `${monthItemPrefix}-button`,
  divStartSelected: `${monthItemPrefix}-divStartSelected`,
  divEndSelected: `${monthItemPrefix}-divEndSelected`,
  selected: `${monthItemPrefix}-selected`,
  between: `${monthItemPrefix}-between`,
};

export const DRMPMonthItemContainer = styled(Box)(({ theme }) => ({
  [`&.${monthItemClasses.root}`]: {
    height: "48px",
    width: "64px",
    maxWidth: "64px",
    [`&.${monthItemClasses.between}`]: {
      backgroundColor: theme.palette.border.main,
      borderRadius: "0px",
    },
    [`&.${monthItemClasses.divStartSelected}`]: {
      backgroundColor: theme.palette.border.main,
      borderTopLeftRadius: "64px",
      borderBottomLeftRadius: "64px",
    },
    [`&.${monthItemClasses.divEndSelected}`]: {
      backgroundColor: theme.palette.border.main,
      borderTopRightRadius: "64px",
      borderBottomRightRadius: "64px",
    },
    [`& .${monthItemClasses.button}`]: {
      ...theme.typography.subtitle1,
      height: "48px",
      width: "64px",
      maxWidth: "64px",
      backgroundColor: "transparent",
      border: "unset",
      borderRadius: "64px",
      boxSizing: "border-box",
      padding: theme.spacing(1),
      textTransform: "capitalize",
      color: theme.palette.black.dark,
      transition: "unset",
      "&:hover": {
        cursor: "pointer",
        border: `1px solid ${theme.palette.primary.main}`,
      },
      [`&.${monthItemClasses.selected}`]: {
        backgroundColor: theme.palette.primary.main,
        color: "white",
      },
    },
  },
}));
